import { useEffect } from 'react';

export function useCSS(rule) {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const style = document.createElement('style');
    const { sheet } = style;
    if (sheet?.insertRule) {
      sheet.insertRule(rule, 0);
    } else if (sheet?.addRule) {
      sheet.addRule(rule);
    } else {
      style.innerHTML = rule;
    }
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, [rule]);
}
